import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { getRatio } from "../../components/column-ratio"
import { GAP_IF_UNDEFINED } from "./constants"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-twocolumns td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }

    .ck-twocolumns img {
      margin-bottom: 18px !important;
    }
  }
`

export function TwoColumns({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    paddingTop: properties.verticalPadding,
    paddingRight: properties.horizontalPadding,
    paddingBottom: properties.verticalPadding,
    paddingLeft: properties.horizontalPadding,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderWidth: properties.borderWidth,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid"
  }

  const gap =
    (properties.gap === undefined ? GAP_IF_UNDEFINED : properties.gap) / 2

  return (
    <div
      className="ck-twocolumns ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{
                paddingRight: gap,
                verticalAlign: properties.verticalAlign
              }}
            >
              <LiteSlateEditor block_id={children[0].block_id} />
            </td>
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{
                paddingLeft: gap,
                verticalAlign: properties.verticalAlign
              }}
            >
              <LiteSlateEditor block_id={children[1].block_id} />
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
